import { ChakraProvider } from '@chakra-ui/react'

import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { GlobalStyles } from '../GlobalStyles/GlobalStyles'

export const SwashbuckleProvider = ({ theme, prepend = false, children }) => {
  const swashbuckleCache = createCache({
    key: 'homebot',
    prepend,
  })

  return (
    <CacheProvider value={swashbuckleCache}>
      <ChakraProvider theme={theme}>
        <GlobalStyles />
        {children}
      </ChakraProvider>
    </CacheProvider>
  )
}
